var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import * as React from "react";
const SvgClear = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({ width: 16, height: 16, fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), /* @__PURE__ */ React.createElement("path", { d: "M11.333 4h3.334v1.333h-1.334V14a.667.667 0 0 1-.666.667H3.333A.667.667 0 0 1 2.667 14V5.334H1.333V4h3.334V2c0-.368.298-.667.666-.667h5.334c.368 0 .666.299.666.667v2ZM12 5.333H4v8h8v-8ZM6 2.667V4h4V2.667H6Z", fill: "#AA754D" }));
export { SvgClear as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTExLjMzMyA0aDMuMzM0djEuMzMzaC0xLjMzNFYxNGEuNjY3LjY2NyAwIDAgMS0uNjY2LjY2N0gzLjMzM0EuNjY3LjY2NyAwIDAgMSAyLjY2NyAxNFY1LjMzNEgxLjMzM1Y0aDMuMzM0VjJjMC0uMzY4LjI5OC0uNjY3LjY2Ni0uNjY3aDUuMzM0Yy4zNjggMCAuNjY2LjI5OS42NjYuNjY3djJaTTEyIDUuMzMzSDR2OGg4di04Wk02IDIuNjY3VjRoNFYyLjY2N0g2WiIgZmlsbD0iI0FBNzU0RCIvPjwvc3ZnPg==";
